import { useSearchParams } from "react-router-dom";
import {React, useEffect, useState} from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { getFirestore, doc, setDoc, getDoc, updateDoc, serverTimestamp } from "firebase/firestore";

const db = getFirestore();


const PaymentSuccess = () => {
    const navigate = useNavigate();  
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get("session_id");
    const [eventType, setEventType] = useState("Fetching...");

    // const userId = searchParams.get("userId");
    // const consultantId = searchParams.get("consultantId");
    // const amount = parseFloat(searchParams.get("amount"));
    



    useEffect(() => {
      const fetchSessionDetails = async () => {
          if (!sessionId) return;

          try {
              const response = await fetch(`/api/get-session?session_id=${sessionId}`);
              const data = await response.json();

              // Then extract these from Stripe metadata:
              const userId = data.metadata.userId;
              const consultantId = data.metadata.consultantId;
              const amount = parseFloat(data.metadata.amount);

              console.log('data: ', data)
              

              if (data.eventType) {
                  console.log("Last Stripe Event:", data.eventType);
                  setEventType(data.eventType);
              } else {
                  console.log("No event type found.");
              }

              // ✅ Update Firestore with the payment
              const payRef = doc(db, "priestsPay", consultantId, "users", userId);
              const paySnap = await getDoc(payRef);

              if (paySnap.exists()) {
                const prevAmount = paySnap.data().totalAmountPaid || 0;
                await updateDoc(payRef, {
                  totalAmountPaid: prevAmount + amount,
                  lastPaidAt: serverTimestamp()
                });
              } else {
                await setDoc(payRef, {
                  totalAmountPaid: amount,
                  lastPaidAt: serverTimestamp()
                });
              }

              console.log("Firestore updated successfully.");

          } catch (error) {
              console.error("Error fetching session details:", error);
          }
      };

      fetchSessionDetails();
  }, [sessionId]);


    return (
        <Container className="text-center mt-5">
              <Row className="justify-content-center">
                <Col md={6}>
                  <FaCheckCircle size={60} className="text-success mb-3" />
                  <h2 className="text-success">Payment Successful</h2>
                  <p className="text-muted">
                    Thank you! Your payment is successful. You have now been credited with your cowries.
                    <img 
                        src="/cowrieblack.png" // Update with the correct path
                        alt="Feather Icon" 
                        style={{ width: '20px', height: '20px'}} 
                    />
                  </p>
                  <p><strong>Last Stripe Event:</strong> {eventType}</p>
                  {/* <Button variant="primary" onClick={() => navigate("/checkout")}>
                    Retry Payment
                  </Button> */}
                  <Button variant="link" className="mt-3" onClick={() => navigate("/")}>
                    Go Home
                  </Button>
                </Col>
              </Row>
            </Container>
    );
}

export default PaymentSuccess;
